/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlClientRoles } from './ControlClientRoles';
import {
    ControlClientRolesFromJSON,
    ControlClientRolesFromJSONTyped,
    ControlClientRolesToJSON,
} from './ControlClientRoles';
import type { ControlLocale } from './ControlLocale';
import {
    ControlLocaleFromJSON,
    ControlLocaleFromJSONTyped,
    ControlLocaleToJSON,
} from './ControlLocale';

/**
 * 
 * @export
 * @interface ControlUserMeResponse
 */
export interface ControlUserMeResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlUserMeResponse
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserMeResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUserMeResponse
     */
    client_id: string;
    /**
     * 
     * @type {ControlLocale}
     * @memberof ControlUserMeResponse
     */
    locale: ControlLocale;
    /**
     * 
     * @type {boolean}
     * @memberof ControlUserMeResponse
     */
    msp: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlUserMeResponse
     */
    policyholder: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlUserMeResponse
     */
    premium: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlUserMeResponse
     */
    entity_id: string;
    /**
     * 
     * @type {ControlClientRoles}
     * @memberof ControlUserMeResponse
     */
    client_role: ControlClientRoles;
}

/**
 * Check if a given object implements the ControlUserMeResponse interface.
 */
export function instanceOfControlUserMeResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_id" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "client_id" in value;
    isInstance = isInstance && "locale" in value;
    isInstance = isInstance && "msp" in value;
    isInstance = isInstance && "policyholder" in value;
    isInstance = isInstance && "premium" in value;
    isInstance = isInstance && "entity_id" in value;
    isInstance = isInstance && "client_role" in value;

    return isInstance;
}

export function ControlUserMeResponseFromJSON(json: any): ControlUserMeResponse {
    return ControlUserMeResponseFromJSONTyped(json, false);
}

export function ControlUserMeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlUserMeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_id': json['user_id'],
        'email': json['email'],
        'client_id': json['client_id'],
        'locale': ControlLocaleFromJSON(json['locale']),
        'msp': json['msp'],
        'policyholder': json['policyholder'],
        'premium': json['premium'],
        'entity_id': json['entity_id'],
        'client_role': ControlClientRolesFromJSON(json['client_role']),
    };
}

export function ControlUserMeResponseToJSON(value?: ControlUserMeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.user_id,
        'email': value.email,
        'client_id': value.client_id,
        'locale': ControlLocaleToJSON(value.locale),
        'msp': value.msp,
        'policyholder': value.policyholder,
        'premium': value.premium,
        'entity_id': value.entity_id,
        'client_role': ControlClientRolesToJSON(value.client_role),
    };
}

